import React from "react";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import Hero from "../components/about-us/Hero";
import Purpose from "../components/about-us/Purpose";
import MissionOffer from "../components/about-us/MissionOffer";
import Safety from "../components/about-us/Safety";
import Vision from "../components/about-us/Vision";
import JoinJourney from "../components/about-us/JoinJourney";
import SEO from "../components/shared/SEO";

export default function AboutUs() {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <SEO
        title="About Us | SoloConnect - Connecting Solo Travelers Worldwide"
        description="Learn about the mission, vision, and team behind SoloConnect, the ultimate app designed to help solo travelers find verified buddies and explore destinations safely."
        keywords="about solo travel companion, mission, team, vision, verified travelers, safe exploration"
      />
      <Newnabar />
          
      
      
      <main className="">
       <div data-aos="zoom-in">
         <Hero />
       </div>
       <div data-aos="fade-up">
         <Purpose />
       </div>
       <div data-aos="fade-up" data-aos-delay="100">
         <MissionOffer />
       </div>
       <div data-aos="fade-up">
         <Safety />
       </div>
       <div data-aos="fade-left">
         <Vision />
       </div>
       <div data-aos="zoom-in-up">
         <JoinJourney />
       </div>
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
